import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDownIcon } from 'lucide-react';
const faqs = [{
  q: 'È una dieta?',
  a: 'No. È un sistema alimentare. Non elimina nessun alimento, non impone calorie e non crea sensi di colpa.'
}, {
  q: 'Devo cucinare molto?',
  a: 'No. La maggior parte delle ricette richiede meno di 20 minuti. Il Meal Prep ti insegna a preparare tutto in una sessione settimanale.'
}, {
  q: 'Servono ingredienti costosi?',
  a: 'No. Solo ingredienti reperibili in qualsiasi supermercato italiano.'
}, {
  q: 'Come ricevo i materiali?',
  a: 'Immediatamente dopo il pagamento ricevi i link per scaricare tutti i PDF. Accessibili per sempre da qualsiasi dispositivo.'
}, {
  q: 'Come funziona la garanzia?',
  a: 'Scrivi una email entro 7 giorni. Rimborso completo — senza domande.'
}, {
  q: 'È adatto a chi ha intolleranze?',
  a: 'Sì, il Tomo 5 è interamente dedicato a ricette senza glutine e senza zucchero, e molte altre ricette sono facilmente adattabili.'
}, {
  q: 'Posso seguirlo se mangio spesso fuori casa?',
  a: 'Assolutamente. Il sistema ti insegna i principi per fare scelte migliori anche al ristorante o in pausa pranzo.'
}, {
  q: 'Il pagamento è sicuro?',
  a: 'Sì, utilizziamo circuiti sicuri e crittografati. Accettiamo tutte le principali carte di credito e debito.'
}, {
  q: 'Cosa include esattamente il Metodo Reset 21 Giorni?',
  a: 'È un protocollo guidato passo-passo di 3 settimane (Organizza, Attiva, Consolida) per resettare le abitudini senza stress. Incluso solo nel pacchetto Premium.'
}, {
  q: 'Posso scaricare i file sul telefono?',
  a: 'Sì, i PDF sono ottimizzati per essere letti comodamente su smartphone, tablet e computer.'
}];
export function FAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section className="py-16 px-4 bg-brand-warm" data-id="element-84">
      <div className="max-w-2xl mx-auto" data-id="element-85">
        <motion.h2 initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-2xl sm:text-3xl font-serif font-bold text-center mb-10 text-brand-text-main" data-id="element-86">
          Domande Frequenti
        </motion.h2>

        <div className="space-y-3" data-id="element-87">
          {faqs.map((faq, i) => <motion.div key={i} initial={{
          opacity: 0,
          y: 10
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: i * 0.04
        }} className="bg-white border border-brand-sage/20 rounded-xl overflow-hidden shadow-sm" data-id="element-88">
              <button onClick={() => setOpenIndex(openIndex === i ? null : i)} className="w-full px-6 py-5 text-left flex justify-between items-center hover:bg-brand-sage-light transition-colors gap-4" data-id="element-89">
                <span className="font-bold text-brand-text-main text-sm sm:text-base" data-id="element-90">
                  {faq.q}
                </span>
                <ChevronDownIcon className={`w-5 h-5 text-brand-olive transition-transform duration-300 shrink-0 ${openIndex === i ? 'rotate-180' : ''}`} data-id="element-91" />
              </button>

              <AnimatePresence data-id="element-92">
                {openIndex === i && <motion.div initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: 'auto',
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} transition={{
              duration: 0.25
            }} data-id="element-93">
                    <div className="px-6 pb-5 pt-0 text-brand-text-muted font-medium leading-relaxed" data-id="element-94">
                      {faq.a}
                    </div>
                  </motion.div>}
              </AnimatePresence>
            </motion.div>)}
        </div>
      </div>
    </section>;
}